import PatientDataSummary from "./PatientDataSummary";
export default PatientDataSummary;
